// extracted by mini-css-extract-plugin
module.exports = {"topBar":"Landing_topBar__19gbx","content":"Landing_content__2IGDm","recommended":"Landing_recommended__3rOSf","instant":"Landing_instant__1eLe8","sosBtn":"Landing_sosBtn__3eMf3"};